import React from 'react'
import { MEModal } from '@CommonComponents'

// Warning modal shown before deleting a chapter/section from the ToC editor
export const TocDeleteModal = ({ target, onConfirm, onCancel }) => (
  <MEModal show={!!target} close={onCancel} title="Delete from book?">
    <p>
      Are you sure you want to delete{' '}
      <strong>{target ? target.title : ''}</strong>?
    </p>
    <p>
      This permanently removes it and everything inside it &mdash; including
      any subsections, text, images, and embedded assessments &mdash; from the
      book for all students.
    </p>
    <div className="mt-4 text-center">
      <button
        type="button"
        onClick={onCancel}
        className="btn btn-myed btn-default btn-default-myed mr-3"
      >
        Cancel
      </button>
      <button type="button" onClick={onConfirm} className="btn btn-danger mr-2">
        Delete
      </button>
    </div>
  </MEModal>
)
